// removed by extract-text-webpack-plugin
module.exports = {"footer":"_2nhzBA1RlNKOVN_nNggXzW","container":"_26pKBIAl3afzSXDEOouaAB","omLogo":"oL9zjZ74fQ8VGEpj3IKAy","top":"_3ATjfXhCflIrc_1EnYJzpV","nav":"_36Xgk2u9ejcEjUwcmw30YY","appLinks":"_20qgcur5091K-iDdUNJ5F","social":"l2arYKQXKutoFlW1CakRe","socialLink":"_1QvRvwve59KadQNeK7cvMv","copyright":"_2JmoEA7ljwUeCkn8NIyCkw","copy":"_1oK3Wx7NFLoWUZsBekFXjx","hidden":"_39V4mnV2noerfaytsWD-8e","propertyList":"DeHEh78QRnpOivIWgA4D1","linkWrapper":"uKg2UVlyjF2c5pXP9hy7x","mobileBlock":"UGCxxWCO8TugY3NiQ5JUa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.scss
// module id = 1597
// module chunks = 0